export const customFormMappingObjectTypes = Object.freeze({
  InsuranceAgency: 0,
  Policy: 1,
  Insured: 2,
  Agent: 3,
  Util: 4,
  Vehicle: 5,
  Driver: 6,
  MotorTruckCargo: 7,
  PendingCancellation: 8,
  Property: 9,
  CustomFields: 10,
  CustomText: 11,
  CustomTextCalculated: 12,
});
